import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie'; // 새로고침
import { authApi, setToken, getToken } from '../../../apis';
import { me } from '../../../stores/auth';
import { Button, Form, Input, Checkbox } from 'antd';
import './signin.css';
import bkgSignin from '../../../assets/images/bkg_signin.png';
import useInput from '../../../hooks/useInput';
// ------------------------------------------------------------------------------------------------
// password
import ChangePassword from '../password/change';
import FindPassword from '../password/find';
import ConfirmPassword from '../password/confirm';
// ------------------------------------------------------------------------------------------------

/**
 * 로그인 페이지
 * @author
 * */
const SignIn = (props) => {
  const location = useLocation();
  // ------------------------------------------------------------------------------------------------
  if (location.pathname == '/password/find') {
    return <FindPassword {...props} location={location} />;
  } else if (location.pathname == '/password/change') {
    return <ChangePassword {...props} location={location} />;
  } else if (location.pathname == '/password/confirm') {
    return <ConfirmPassword {...props} location={location} />;
  }
  // ------------------------------------------------------------------------------------------------
  const [cookie, setCookie] = useCookies(['token']);
  const dispatch = useDispatch();
  const signIn = () => {
    try {
      return localStorage && localStorage.getItem('signIn');
    } catch (e) {}

    return {};
  };
  const { username: initUserName } = JSON.parse(signIn()) || {};
  const username = useInput(initUserName || '');
  const password = useInput('');
  const [loading, setLoading] = useState(false);

  const [autoLogin, setAutoLogin] = useState(
    String(initUserName || '').length > 0 ? true : false
  );

  useEffect(() => {
    // 자동 로그인 획안
    if (initUserName && initUserName.length > 0) {
      if (getToken(setCookie)) {
        onFinish();
      }
    }
  }, []);

  // 로그인
  const onFinish = async () => {
    if (loading) return;
    try {
      setLoading(true);

      const requestBody = {
        // username: username.value || 'admin@admin.com',
        email: username.value,
        password: password.value,
      };

      const { data: responseData } = await authApi.post(
        `/admin/signin`,
        requestBody
      );
      // console.log('--->', responseData);
      // 자동 로그인
      if (autoLogin) {
        localStorage.setItem('signIn', JSON.stringify(requestBody));
      } else {
        localStorage.setItem('signIn', null);
      }
      if (responseData && responseData.payload) {
        setToken(responseData.payload, setCookie);
        await dispatch(me());
      } else {
        throw responseData;
      }
    } catch (e) {
      console.warn('[sign in]', e);
      // alert(e.response.data && e.response.data.message);
    }
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="topArea">
        <div className="topBox" style={{ marginTop: '1rem' }} />
        <div className="topBorderBox" style={{ marginLeft: '-5rem' }} />
      </div>
      <div style={{ height: '32rem' }} />
      <div className="bottomArea">
        <div className="bottomBorderBox" style={{ marginRight: '8rem' }}>
          <div className="bottomBox" />
        </div>
      </div>
      <div
        className="centerArea"
        style={{
          marginTop: '-65rem',
          marginLeft: '-8rem',
          backgroundImage: `url(${bkgSignin})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          paddingTop: '23rem',
          paddingLeft: '3.2rem',
        }}
      >
        <Form onFinish={onFinish}>
          <div
            style={{
              alignItem: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Form.Item noStyle name={'username'}>
              <Input
                placeholder={username.value || 'Admin@Balancefit.kr'}
                className={'input'}
                allowClear
                {...username}
              />
            </Form.Item>
            <div
              style={{
                display: 'flex',
                width: '100%',
                marginTop: '0.1rem',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                type="link"
                style={{
                  height: '2rem',
                  padding: 0,
                  fontSize: '1.3rem',
                  lineHeight: '1.5rem',
                  color: '#7367F0',
                  marginTop: '0.8rem',
                  marginBottom: '0.8rem',
                }}
                onClick={(e) => {
                  // console.log('password');
                  // navigate('/password/find', { replace: true });
                  // redirect('/password/find');
                  window.location.replace('/password/find');
                }}
              >{`비밀번호 찾기`}</Button>
            </div>
            <Form.Item noStyle name={'password'}>
              <Input.Password
                placeholder={'********'}
                className={'input'}
                allowClear
                {...password}
              />
            </Form.Item>
            {/* 자동 로그인 */}
            <Checkbox
              style={{ marginTop: '0.2rem' }}
              defaultChecked={autoLogin}
              onChange={(e) => {
                // console.log('checked = ', e.target.checked);
                setAutoLogin((prev) => !prev);
              }}
            />
            {/* Button */}
            <Button
              type="primary"
              htmlType={'submit'}
              loading={loading}
              style={{
                marginTop: '1.6rem',
                display: 'flex',
                width: '100%',
                height: '3.8rem',
                justifyContent: 'center',
                alignItem: 'center',
                background: '#7367F0',
                // font
                fontWeight: 500,
                fontSize: '1.5rem',
              }}
            >
              로그인
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SignIn;
